import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/view',
        name: 'View',
        component: () => import('../views/View.vue')
    },
    {
        path: '/data',
        name: 'Data',
        component: () => import('../views/Data.vue')
    },
    {
        path: '/footprint',
        name: 'FootPrint',
        component: () => import('../views/FootPrint.vue')
    },
    {
        path: '/rule',
        name: 'Rule',
        component: () => import('../views/Rule.vue')
    },
    {
        path: '/list',
        name: 'List',
        component: () => import('../views/List.vue')
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
